import { ShieldCheck, Crosshair, Cpu, Timer, Award, TrendingUp } from "lucide-react";
import { Section, Kicker, Reveal } from "./primitives";

const BENEFITS = [
  { icon: ShieldCheck, t: "Seguridad absoluta", d: "Te plantarás frente a un analizador fuera de servicio sabiendo exactamente qué paso dar desde el minuto uno." },
  { icon: Crosshair, t: "Calibraciones a la primera", d: "Lograrás curvas de calibración perfectamente lineales sin desperdiciar reactivos ni perder horas de prueba." },
  { icon: Cpu, t: "Criterio técnico superior", d: "Entenderás el comportamiento de la luz, los filtros y la fluídica desde la electrónica y la hidráulica, sin ser químico o bacteriólogo." },
  { icon: Timer, t: "Diagnósticos quirúrgicos", d: "Reducirás el tiempo de resolución de 4 horas de incertidumbre a 20 minutos de aislamiento metódico." },
  { icon: Award, t: "Autoridad y respeto", d: "Ganarás la confianza total de bacteriólogos y directores de laboratorio, que no dudarán en llamarte ante cualquier emergencia." },
  { icon: TrendingUp, t: "Ingresos de especialista", d: "Dejarás de mendigar tarifas bajas para cobrar contratos y mantenimientos de alto valor que reflejen tus años de estudio." },
];

export const Beneficios = () => (
  <Section id="beneficios">
    <Reveal>
      <Kicker num="03" label="Tu nueva realidad profesional" />
      <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
        ¿Qué significa dominar este método en tu día a día?
      </h2>
    </Reveal>

    <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {BENEFITS.map((b, i) => (
        <Reveal key={b.t} delay={i * 0.07} className="h-full">
          <div className="group h-full rounded-2xl border border-white/10 bg-[#0E1524]/70 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-cyan-400/40 hover:shadow-[0_18px_50px_rgba(6,182,212,0.12)]">
            <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-400/25 bg-cyan-400/10 text-cyan-300 transition-transform duration-300 group-hover:scale-110">
              <b.icon className="h-5 w-5" />
            </div>
            <h3 className="font-display text-lg font-semibold text-slate-50 sm:text-xl">{b.t}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{b.d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);
